import packageJson from '../../package.json'

/** App-specific navigation chrome supplied to `@suntex.fim/nav`: the app version consumed by the FIM layout wrappers. */
export const layoutChrome = {
  appVersion: packageJson.version
}
